'use client';

import { cn } from '@/lib/utils';
import { Progress } from './progress';

interface ProgressToastProps {
  value: number;
  visible?: boolean;
  label?: string;
  description?: string;
  className?: string;
  instant?: boolean;
  toastId?: string;
  onCancel?: () => void;
  cancelLabel?: string;
}

export function ProgressToast({
  value,
  visible = true,
  label = 'Procesando...',
  description = 'Esto puede tardar unos minutos...',
  className,
  instant = false,
  toastId,
  onCancel,
  cancelLabel = 'Cancelar',
}: ProgressToastProps) {
  const isDone = value >= 100;

  return (
    <div
      data-testid={toastId ? `progress-toast-${toastId}` : undefined}
      className={cn(
        'w-72 bg-white rounded-2xl shadow-lg border border-gray-100 p-4 flex flex-col gap-3 transition-all duration-300',
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2',
        className,
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex flex-col gap-0.5">
          <span className="text-sm font-semibold text-gray-800">{label}</span>
          <span
            data-testid={toastId ? `progress-toast-${toastId}-description` : undefined}
            className="text-xs text-gray-400"
          >
            {isDone ? 'Completado' : description}
          </span>
        </div>
        <span
          data-testid={toastId ? `progress-toast-${toastId}-percent` : undefined}
          className="text-xs font-semibold text-blue-500 shrink-0 mt-0.5"
        >
          {Math.round(value)}%
        </span>
      </div>
      <Progress value={value} instant={instant} className="h-1.5" />
      {onCancel && !isDone ? (
        <button
          type="button"
          className="self-end rounded-sm text-xs font-semibold text-red-600 transition-colors hover:text-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
      ) : null}
    </div>
  );
}
